import React, { useState } from "react";

import { ReactComponent as FileQuestionIcon } from "assets/svg/icons/file-question-02.svg";
import { ReactComponent as FileBlueIcon } from "assets/svg/icons/file-blue.svg";
import { ReactComponent as FileRedIcon } from "assets/svg/icons/file-red.svg";
import { ReactComponent as FileYellowIcon } from "assets/svg/icons/file-yellow.svg";
import { ReactComponent as FileGreenIcon } from "assets/svg/icons/file-green.svg";
import { ReactComponent as XCircleIcon } from "assets/svg/icons/x-circle-1.svg";
import { ReactComponent as ClockIcon } from "assets/svg/icons/clock.svg";
import { ReactComponent as MinusCircleIcon } from "assets/svg/icons/minus-circle.svg";
import { ReactComponent as CheckCircleIcon } from "assets/svg/icons/check-circle-1.svg";

import "./styles.scss";
import CustomizedTooltip from "../Tooltip/Tooltip";

const DocumentOrFileStatusIcon = ({
  isDocument = true,
  status,
  isPDF = false,
  itsButton = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const background = {
    UploadedNeeded: "#F5F5F5",
    PendingReview: "#D1E9FF",
    Accepted: "#D0F0E5",
    Rejected: "#FEE4E2",
    InReview: "#FEF0C7",
  }[status];

  const icon = isDocument
    ? {
        UploadedNeeded: <FileQuestionIcon />,
        PendingReview: <ClockIcon />,
        Accepted: <CheckCircleIcon />,
        Rejected: <XCircleIcon />,
        InReview: <MinusCircleIcon />,
      }[status]
    : {
        PendingReview: <FileBlueIcon />,
        Accepted: <FileGreenIcon />,
        Rejected: <FileRedIcon />,
        InReview: <FileYellowIcon />,
      }[status];

  const border = {
    PendingReview: "border-blue",
    Accepted: "border-green",
    Rejected: "border-red",
    InReview: "border-yellow",
  }[status];

  const statusForTooltip = {
    UploadedNeeded: "Upload Needed",
    PendingReview: "Pending Review",
    Accepted: "Accepted",
    Rejected: "Rejected",
    InReview: "In Review",
  }[status];

  return (
    <CustomizedTooltip title={statusForTooltip}>
      {itsButton ? (
        <button
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={`${!isPDF ? "iconWrapper" : "iconWrapperBig"} ${
            !isPDF && isFocused && border
          } `}
          style={{ background: `${background}` }}
        >
          {icon}
        </button>
      ) : (
        <div
          className={`${!isPDF ? "iconWrapper" : "iconWrapperBig"} `}
          style={{ background: `${background}` }}
        >
          {icon}
        </div>
      )}
    </CustomizedTooltip>
  );
};

export default DocumentOrFileStatusIcon;
